import React, { useState} from 'react';
import './App.css';
import Main from './Main';
import {Planets} from 'react-preloaders';
import { ParallaxProvider } from 'react-scroll-parallax';
function App() {

  const [btnBool,setBtnBool] = useState(false);

  window.onscroll = function() {scrollFunction()};
  const  scrollFunction = () => {
      if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          setBtnBool(true)
        } else {
          setBtnBool(false)
        }
  }

  return (
    <div className="app">
      <ParallaxProvider><Main bool = {btnBool}/></ParallaxProvider>
      <Planets color = '#39FF14' background = '#000' animation = 'slide-right'/>
    </div>
  );
}

export default App;
